import {createStore,compose,applyMiddleware} from 'redux';
import logger from 'redux-logger';
import rootReducer from './reducers';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createBlacklistFilter } from 'redux-persist-transform-filter';

const persistConfig = {
    key: 'root',
    timeout: 10000,
    storage: storage,
    transforms : [
        createBlacklistFilter('loginData',['accountErrMsg','tokenErrMsg','isLogging']),
        createBlacklistFilter('logoutData',['isLoggingout','loggedout']),
        createBlacklistFilter('quickpayData',['isPaying','paid']),
        createBlacklistFilter('loadTranData',['isLoading','loaded',"transactions","totalTran","totalIncome"]),
    ]
    // stateReconciler: autoMergeLevel2 // see "Merge Process" section for details.
};

const pReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// export const store = createStore(pReducer,applyMiddleware(thunkMiddleware,logger));
export const store = createStore(pReducer, composeEnhancers(
  applyMiddleware(thunkMiddleware),
));

export const persistor = persistStore(store);
